/**
 * AntdStaticFunctionHolder
 * 
 * This component captures the modal, message, and notification instances from App.useApp()
 * and stores them in module-level variables so they can be used by utility functions
 * that can't use hooks directly.
 * 
 * This enables utility functions like openNotificationWithIcon() to respect the theme.
 */
import { App } from 'antd'
import { useEffect } from 'react'

// Module-level storage for the instances
let modalInstance = null
let messageInstance = null
let notificationInstance = null

// Getters for utility functions to use
export const getModal = () => modalInstance
export const getMessage = () => messageInstance
export const getNotification = () => notificationInstance

/**
 * Component that captures and stores the App.useApp() instances.
 * Must be rendered inside <App> component.
 */
const AntdStaticFunctionHolder = () => {
    const { modal, message, notification } = App.useApp()

    useEffect(() => {
        modalInstance = modal
        messageInstance = message
        notificationInstance = notification
    }, [modal, message, notification])

    return null
}

export default AntdStaticFunctionHolder


